import Head from "next/head"
import React from "react"

class Metatags extends React.Component {
    render() {
        return (
            <Head>
                <meta charSet="utf-8" />
                <meta httpEquiv="x-ua-compatible" content="IE=edge" />
                <meta name="apple-mobile-web-app-capable" content="yes" />

                {/* Use minimum-scale=1 to enable GPU rasterization */}
                <meta
                    name="viewport"
                    content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
                />
            </Head>
        )
    }
}

export default Metatags
